<template>
    <div>
        <el-form v-if="datas" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm scroll-auto" label-position="left">
            <el-form-item label="商品名称" prop="name">
                <el-input v-model="datas.tits" :disabled="true" maxlength="40" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="商品主图" prop="zhuFile">
                <el-upload action="https://jsonplaceholder.typicode.com/posts/" list-type="picture-card" :file-list="ruleForm.zhuFile" :auto-upload="false">
                    <div slot="file" slot-scope="{ file }">
                        <img style="width: 100%; height: 100%; background-size: 100% 100%" class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                        <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                        </span>
                    </div>
                </el-upload>
            </el-form-item>
            <el-form-item>
                <el-link type="danger" :underline="false">图片尺寸建议600*600像素内，上传的图片默认自然排序</el-link>
            </el-form-item>
            <el-form-item label="商品轮播图" prop="lbFile">
                <el-upload action="https://jsonplaceholder.typicode.com/posts/" list-type="picture-card" :file-list="ruleForm.lbFile" :auto-upload="false">
                    <div slot="file" slot-scope="{ file }">
                        <img style="width: 100%; height: 100%; background-size: 100% 100%" class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                        <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                        </span>
                    </div>
                </el-upload>
            </el-form-item>
            <el-form-item label="商品详情图" prop="detailFile">
                <el-upload action="https://jsonplaceholder.typicode.com/posts/" list-type="picture-card" :file-list="ruleForm.detailFile" :auto-upload="false">
                    <div slot="file" slot-scope="{ file }">
                        <img style="width: 100%; height: 100%; background-size: 100% 100%" class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                        <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                        </span>
                    </div>
                </el-upload>
            </el-form-item>
            <el-form-item label="分类类型" prop="region">
                <el-select v-model="datas.classifys_type_id" :disabled="true" placeholder="请选择分类类型">
                    <el-option label="虚拟商品(暂未开放，尽请期待)" :disabled="true" value="2001"></el-option>
                    <el-option label="实物商品" value="2000"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="品牌类型" prop="goods_brands_id">
                <el-select v-model="ruleForm.goods_brands_id" disabled filterable remote reserve-keyword placeholder="请输入关键词" :remote-method="remoteMethod" :loading="loading">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="商品分类" prop="prolei">
                <el-cascader style="width: 35%" :disabled="true" :props="{ value: 'id', label: 'name' }" v-model="ruleForm.prolei" :options="customers"></el-cascader>
            </el-form-item>
            <el-form-item label="商品参数" prop="attribute" required>
                <div class="bg">
                    <el-row :gutter="40">
                        <el-col :span="12">
                            <el-row :gutter="10">
                                <el-col :span="6"><label for="">商品重量</label></el-col>
                                <el-col :span="18"
                                    ><el-input v-model="ruleForm.attribute.net_weight" disabled clearable> <template slot="append">kg</template></el-input></el-col
                                >
                            </el-row>
                        </el-col>
                        <el-col :span="12">
                            <el-row :gutter="10">
                                <el-col :span="6"><label for="">型号</label></el-col>
                                <el-col :span="18"><el-input v-model="ruleForm.attribute.marque" disabled clearable></el-input></el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="12">
                            <el-row :gutter="10">
                                <el-col :span="6"><label for="">包装尺寸</label></el-col>
                                <el-col :span="18"
                                    ><el-input v-model="ruleForm.attribute.volume" disabled clearable>
                                        <template slot="append">cm</template>
                                    </el-input></el-col
                                >
                            </el-row>
                        </el-col>
                        <el-col :span="12">
                            <el-row :gutter="10">
                                <el-col :span="6"><label for="">产地</label></el-col>
                                <el-col :span="18"><el-input v-model="ruleForm.attribute.country_of_origin" disabled clearable></el-input></el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </div>
            </el-form-item>
            <el-form-item label="规格" :required="true">
                <el-radio v-model="datas.goods_specifications_type_id" :disabled="true" label="1">单规格</el-radio>
                <el-radio v-model="datas.goods_specifications_type_id" :disabled="true" label="2">多规格</el-radio>
            </el-form-item>
            <el-form-item label="商品销售价" prop="xsj">
                <el-input-number v-model="datas.prices_mains" :disabled="true" :min="0" style="width: 250px; margin-right: 5px" placeholder="请输入销售价(元)"></el-input-number>
            </el-form-item>
            <el-form-item label="商品市场价" prop="scj">
                <el-input-number v-model="datas.prices_defaults" :disabled="true" :min="0" style="width: 250px; margin-right: 5px" placeholder="商品市场价(元)"></el-input-number>
            </el-form-item>
            <el-form-item v-if="datas.goods_specifications_type_id == 1" v-model="ruleForm.kc" prop="kc" label="库存">
                <el-input-number v-model="datas.merchandise_inventory" :disabled="true" :min="0" style="width: 250px; margin-right: 5px" placeholder="库存"></el-input-number>
            </el-form-item>
            <el-form-item v-if="datas.goods_specifications_type_id == 2" label="商品规格" prop="guigeList">
                <!-- <div class="items" v-for="(item,index) in ruleForm.guigeList" :key="index"
                 style="margin-top:10px;background:#cccccc7a;padding:10px; border-radius: 8px;box-sizing: border-box;">
                     <div class="top"><el-button type="warning">{{getGuival(item.ggname)}}</el-button></div>
                     <div class="yiji" style="margin-top:10px;">
                          <span style="margin-left:10px;">规格名：</span>
                         <el-button>{{item.value}}</el-button>
                        <div class="erji" v-for="(item2,index) in item.childern2" :key="index" style="margin-top:10px;">
                              <div class="top" v-if="index==0"><el-button type="warning">{{getGuival(item2.name)}}</el-button></div>
                              <div class="erjiConitem"  style="margin-top:10px;">
                                  <span style="margin-left:10px;">规格值：</span>
                                     <el-button>{{item2.value}}</el-button>
                                  <span style="margin-left:10px;">销售价：</span>
                                     <el-input-number v-model="item2.xsj" :min="0"  style="width:180px;margin-right:5px;margin-top:10px"></el-input-number>
                                  <span style="margin-left:10px;">市场价：</span>
                                     <el-input-number v-model="item2.scj" :min="0"  style="width:180px;margin-right:5px;margin-top:10px"></el-input-number>
                                 <span style="margin-left:10px;">库存：</span>
                                     <el-input-number v-model="item2.kc" :min="0"  style="width:180px;margin-right:5px;margin-top:10px"></el-input-number>
                              </div>
                        </div>
                     </div>
                </div> -->
                <div v-if="ruleForm.guigeList.length > 0" class="table">
                    <el-table :data="tableData" style="width: 100%">
                        <el-table-column prop="name" label="规格值*规格值"> </el-table-column>
                        <el-table-column prop="xsj" label="销售价(元)"> </el-table-column>
                        <el-table-column prop="scj" label="市场价(元)"> </el-table-column>
                        <el-table-column prop="kc" label="库存"> </el-table-column>
                    </el-table>
                </div>
            </el-form-item>
            <el-form-item label="快递费" :required="true">
                <!-- 9.16产品要求隐藏 -->
                <!-- <p>
                    <el-radio v-model="yf" label="1">统一运费</el-radio>
                    <span v-if="yf == '1'"><el-input-number placeholder="运费" v-model="yfprice" :min="0" style="width: 180px; margin-left: 10px; margin-right: 5px"></el-input-number>元</span>
                </p> -->
                <div class="flex">
                    <el-radio v-model="yf" label="2" disabled>包邮</el-radio>
                    <el-input v-model="ruleForm.send_goods_time" style="width: 240px" clearable disabled>
                        <template slot="append">小时内发货</template>
                    </el-input>
                </div>
            </el-form-item>
            <el-form-item label="发货地址" prop="warehouse_address_id" class="close" required>
                <el-select v-model="ruleForm.warehouse_address_id" disabled placeholder="请选择发货地址" clearable>
                    <el-option v-for="item in warehouseList" :key="item.id" :label="item.title" :value="item.id"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="是否自动上架" prop="put_on_sale">
                <el-radio-group v-model="datas.put_on_sale" disabled>
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否支持7天无理由退货" prop="unconditional_return">
                <el-radio-group v-model="ruleForm.unconditional_return" disabled>
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm">确定</el-button>
            </el-form-item>
        </el-form>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
    data() {
        return {
            options: [],
            ruleForm: {
                warehouse_address_id: "",
                send_goods_time: "",
                name: "",
                region: "2000", //分类
                goods_brands_id: "",
                prolei: [], //商品分类
                zhuFile: [], //主图
                lbFile: [], //轮播图
                guigeList: [],
                xsj: undefined, //销售价
                scj: undefined, //市场价
                kc: undefined, //库存
                detailFile: [], //详情图
                imgs_mains: "", //主图url
                put_on_sale: 0,
                unconditional_return: 1,
                attribute: {
                    net_weight: "",
                    marque: "",
                    volume: "",
                    country_of_origin: "",
                },
            },
            customers: [],
            Guigename: [],
            guigelist: [
                { id: 1, value: "" },
                { id: 2, value: "" },
                { id: 3, value: "" },
            ],
            ggname: "",
            ggvalue: "",
            Spec: "1",
            yf: "2",
            yfprice: undefined,
            dialogImageUrl: "",
            dialogVisible: false,
            insertggm: false,
            tableData: [],
            datas: {},
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入商品名称",
                        trigger: "blur",
                    },
                    {
                        min: 0,
                        max: 40,
                        message: "商品名称不能超过40个字符",
                        trigger: "blur",
                    },
                ],
                zhuFile: [{ required: true, message: "请上传主图" }],
                lbFile: [{ required: true, message: "请上传商品轮播图" }],
                region: [
                    {
                        required: true,
                        message: "请选择分类类型",
                        trigger: "blur",
                    },
                ],
                goods_brands_id: [
                    {
                        required: true,
                        message: "请选择品牌类型",
                        trigger: "blur",
                    },
                ],
                prolei: [
                    {
                        required: true,
                        message: "请选择商品分类",
                        trigger: "blur",
                    },
                ],
                xsj: [
                    {
                        required: true,
                        message: "请填写销售价格",
                        trigger: "blur",
                    },
                ],
                scj: [
                    {
                        required: true,
                        message: "请填写市场价",
                        trigger: "blur",
                    },
                ],
                kc: [{ required: true, message: "请填写库存", trigger: "blur" }],
                detailFile: [
                    {
                        required: true,
                        message: "请上传商品详情图",
                        trigger: "blur",
                    },
                ],
                guigeList: [
                    {
                        required: true,
                        message: "请填写商品规格",
                        trigger: "blur",
                    },
                ],
                put_on_sale: [
                    {
                        required: true,
                        message: "请选择是否自动上架",
                        trigger: "change",
                    },
                ],
                unconditional_return: [
                    {
                        required: true,
                        message: "请选择是否支持7天无理由退货",
                        trigger: "change",
                    },
                ],
            },
            timer: null,
            loading: false,
        };
    },
    created() {
        this.leixChange();
        this.bindName();
        this.Bind();
    },
    props: {
        ids: {
            type: Number,
        },
        warehouseList: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    methods: {
        ...mapActions({
            getGoodLei: "commodity/getGoodLei",
            getProDetails: "commodity/newGoodsDetail",
            getGuiDetails: "commodity/getGuiDetails",
            getGuiNameList: "commodity/getGuiNameList",
            getListbrand: "commodity/getListbrand",
        }),
        getSearchData(query) {
            this.getListbrand({ name: query }).then((res) => {
                this.loading = false;
                if (res.code == 1) {
                    this.options = res.data.list.map((item) => {
                        return { value: item.id, label: item.name };
                    });
                }
            });
        },
        remoteMethod(query) {
            if (query !== "") {
                this.loading = true;
                if (this.timer) {
                    clearTimeout(this.timer);
                }
                this.timer = setTimeout(() => {
                    this.getSearchData(query);
                }, 800);
            } else {
                this.options = [];
            }
        },
        getGuival(val) {
            for (let i = 0; i < this.Guigename.length; i++) {
                if (this.Guigename[i].id == val) {
                    return this.Guigename[i].title;
                }
            }
        },
        bindName() {
            this.getGuiNameList({
                token: this.$store.state.token, //必填 商户验证token
                column: ["id", "title"], //非必填  展示字段
                filter: {}, //非必填  查询条件
                offset: 0, //从第几条开始取， 0代表从第一条开始取
                limit: 0, //每页取多少tiao
            }).then((res) => {
                if (res.code == 1) {
                    this.Guigename = res.data.list;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        Bind() {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.getProDetails({
                token: this.$store.state.token,
                id: this.ids,
            }).then((res) => {
                if (res.code == 1) {
                    this.options = [{ value: res.data.goods_brands_id, label: res.data.goods_brands_name }];
                    this.datas = res.data;
                    this.ruleForm.goods_brands_id = res.data.goods_brands_id;
                    this.datas.put_on_sale = Number(res.data.put_on_sale);
                    this.ruleForm.zhuFile = [
                        {
                            url: res.data.imgs_mains,
                        },
                    ];
                    this.yf = "2";
                    this.ruleForm.warehouse_address_id = res.data.warehouse_address_id;
                    this.ruleForm.send_goods_time = res.data.send_goods_time;
                    this.ruleForm.attribute = {
                        net_weight: res.data.net_weight,
                        marque: res.data.marque,
                        volume: res.data.volume,
                        country_of_origin: res.data.country_of_origin,
                    };
                    let a = res.data.imgs_lists.split(",");
                    for (let i = 0; i < a.length; i++) {
                        this.ruleForm.lbFile.push({
                            url: a[i],
                        });
                    }
                    let b = res.data.goods_detail_imgs;
                    for (let i = 0; i < b.length; i++) {
                        this.ruleForm.detailFile.push({
                            url: b[i].urls,
                        });
                    }
                    this.ruleForm.unconditional_return = Number(res.data.unconditional_return);
                    this.ruleForm.prolei = [Number(res.data.sorts_tops), Number(res.data.second_sorts), Number(res.data.sorts)];
                    this.getGuiDetails({
                        token: this.$store.state.token, //必填 商户验证token
                        list_flg: 1, //非必填  转成两层父子结构
                        column: ["*"], //非必填  展示字段
                        filter: {
                            goods_mains_id: parseInt(res.data.id), //商品表id
                        },
                        offset: 0,
                        limit: 0,
                    }).then((msg) => {
                        loading.close();
                        if (msg.code == 1) {
                            // console.log(msg);
                            let list = msg.data.list_data;
                            if (list && list.length > 0) {
                                let listit = [];
                                for (let i = 0; i < list.length; i++) {
                                    let child = [];
                                    for (let j = 0; j < list[i].child.length; j++) {
                                        child.push({
                                            id: list[i].child[j].id,
                                            name: list[i].child_id,
                                            value: list[i].child[j].title.split(",")[1],
                                            xsj: list[i].child[j].prices_mains,
                                            scj: list[i].child[j].prices_defaults,
                                            kc: list[i].child[j].merchandise_inventory,
                                        });
                                    }
                                    listit.push({
                                        ggname: list[i].upid,
                                        value: list[i].title,
                                        gg2name: "",
                                        gg2value: "",
                                        namein: "",
                                        childern2: child,
                                    });
                                }
                                this.ruleForm.guigeList = listit;
                                this.initTable();
                            }
                        } else {
                            this.$message.error(msg.msg);
                        }
                    });
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        leixChange() {
            this.getGoodLei({
                token: this.$store.state.token,
                classifys_type_id: parseInt(this.ruleForm.region),
            }).then((res) => {
                if (res.code == 1) {
                    this.customers = res.data.treeData;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        initTable() {
            this.tableData.splice(0, this.tableData.length);
            for (let i = 0; i < this.ruleForm.guigeList.length; i++) {
                for (let j = 0; j < this.ruleForm.guigeList[i].childern2.length; j++) {
                    this.tableData.push({
                        name: this.ruleForm.guigeList[i].value + "*" + this.ruleForm.guigeList[i].childern2[j].value,
                        xsj: this.ruleForm.guigeList[i].childern2[j].xsj,
                        scj: this.ruleForm.guigeList[i].childern2[j].scj,
                        kc: this.ruleForm.guigeList[i].childern2[j].kc,
                    });
                }
            }
        },
        insertGgm() {
            this.insertggm = false;
        },
        insertYI() {
            if (this.ggname != "" && this.ggvalue != "") {
                this.ruleForm.guigeList.push({
                    ggname: this.ggname,
                    value: this.ggvalue,
                    gg2name: "",
                    gg2value: "",
                    namein: "",
                    childern2: [],
                });
                this.ggvalue = "";
                // item.gg2name
            }
        },
        insertER(item) {
            if (item.gg2name != "" && item.gg2value != "") {
                item.childern2.push({
                    name: item.gg2name,
                    value: item.gg2value,
                    xsj: "",
                    scj: "",
                    kc: "",
                });
                item.gg2value = "";
            }
        },
        deleteers(item) {
            item.childern2.splice(0, item.childern2.length);
        },
        deleteER(item, child) {
            item.childern2.splice(item.childern2.indexOf(child), 1);
        },
        deleteYI(item) {
            this.ruleForm.guigeList.splice(this.ruleForm.guigeList.indexOf(item), 1);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        submitForm() {
            this.$emit("detailsOk");
        },
    },
};
</script>
<style lang='scss' scoped>
::v-deep .el-upload--picture-card {
    display: none;
}
.demo-ruleForm {
    max-height: 600px;
    height: 600px;
    overflow-x: hidden;
}
.bg {
    padding: 24px;
    padding-bottom: 4px;
    background: #f5f5f5;
    & > .el-row {
        margin: 0;
        .el-col {
            height: 36px;
            line-height: 36px;
            margin-bottom: 20px;
            text-align: right;
            label {
                padding-right: 14px;
                display: inline-block;
            }
        }
    }
}
::v-deep .close .el-input__validateIcon {
    display: none !important;
}
</style>